import React from "react";
import "./App.css";
import Header from "./components/Header";
import NavBar from "./components/NavBar";
import Services from "./components/Services";
import About from "./components/About";
import Works from "./components/Works";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
class App extends React.Component {
  render() {
    return (
      <React.Fragment>
        <NavBar />
        <Header />
        <Services />
        <About />
        <Contact />
        <Works />
        <Footer />
      </React.Fragment>
    );
  }
}
export default App;
